import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { XmlUploader } from '../custom';

export interface SecondaryResource
    extends
        ng.resource.IResourceClass<ng.resource.IResource<ManualTradeUploadDto>>,
        XmlUploader {
    generateXml: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    uploadAsXML: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    save: ng.resource.IResourceMethod<
        ng.resource.IResource<ManualTradeUploadDto>
    >;
}

function secondaryResource(
    $resource: ng.resource.IResourceService
): SecondaryResource {
    return <SecondaryResource>$resource(
        config.monolithApi + '/secondary-trade-and-trade-proposal',
        {},
        {
            generateXml: {
                method: 'POST',
                url:
                    config.monolithApi +
                    '/secondary-trade-and-trade-proposal/as-xml'
            },
            uploadAsXML: {
                method: 'POST',
                url: config.monolithApi + '/secondary-trade-and-trade-proposal',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        }
    );
}

angular.module('app').factory('secondaryResource', secondaryResource);
